import { UserView } from '@pages/user-view/user-view-routes.names';

export const Appointments = 'appointments';

export const UserViewAppointments = `/${UserView}/${Appointments}`;
